angular.module('siter.io').controller 'Emails', ["$scope", "Restangular", "$modal", "$stateParams", "$state", 'Email', "$rootScope", ($scope, Restangular, $modal, $stateParams, $state, Email, $rootScope) ->

  $scope.state = $state


  # Get site success

  _getEmailSuccess = (siteData) ->
    if siteData.style_attributes
      siteData.style_attributes.maxWidth = parseInt siteData.style_attributes.maxWidth
    $rootScope.site = siteData


  # Get site fail

  _getEmailFail = (response) ->
    $state.go "404"


  # Get current site from route, set to global scope

  Email.get().then _getEmailSuccess, _getEmailFail



  angular.element("body").on "keypress","span[contenteditable]", (e) ->
    return e.which != 13

]





// WEBPACK FOOTER //
// ./src/app/site/email.controller.coffee